<template>
  <div
    ref="container"
    class="sign-button-container"
    style="width: 300px; min-width: 300px; height: 40px; min-height: 40px;"
  >
    <button
      ref="signBtn"
      v-if="!value"
      :disabled="!editable"
      :style="signButtonStyle"
    >
      {{ sign }}
    </button>
    <bltSignatureDisplay :data="data" v-if="value"></bltSignatureDisplay>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import bltSignatureDisplay from "@/common/components/bltSignatureDisplay/bltSignatureDisplay.vue";

export default defineComponent({
  name: "bltSignButton",
  components: {
    bltSignatureDisplay
  },
  props: {
    value: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
    data: {
      type: String,
      default: ""
    },
    guidedDisclosureEnabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      sign: "SIGN" as string
    };
  },
  computed: {
    signButtonStyle(): Record<string, string | number> {
      const glow = this.editable && this.guidedDisclosureEnabled
        ? '0 0 0 2px rgba(255, 226, 153, 0.8), 0 0 18px rgba(238, 187, 52, 0.55)'
        : 'none'

      return {
        height: '100%',
        width: '100%',
        cursor: this.editable ? 'pointer' : 'not-allowed',
        fontSize: '1rem',
        border: '0',
        boxShadow: glow,
        transition: 'box-shadow 160ms ease, filter 160ms ease'
      }
    }
  },
  emits: ["input"],
  mounted() {

    const button = this.$refs.signBtn as HTMLElement | undefined;

    if (!button) return;

    button.addEventListener("click", () => { this.$emit("input", true) })

  }
});
</script>

<style scoped>
.sign-button-container {
  width: 300px;
  min-width: 300px;
  height: 40px;
  min-height: 40px;
}
</style>
